import {
  infoIconOutline,
  pyarmidGradientBlue,
} from '@features/executive-report/images';
import { ImageProps } from '@features/powerpoint';
import { ImageWithMetadata, resizeToHeight } from '@features/powerpoint';

export const images = (brandLogo: ImageWithMetadata | null): ImageProps[] => {
  const resizedBrandLogo = brandLogo
    ? resizeToHeight(brandLogo, 0.41, 2.88)
    : null;

  return [
    ...(resizedBrandLogo
      ? [
          {
            data: resizedBrandLogo.data,
            h: resizedBrandLogo.height,
            w: resizedBrandLogo.width,
            x: 0.67,
            y: 1.25,
          },
        ]
      : []),
    {
      path: pyarmidGradientBlue,
      h: 2.91,
      w: 2.69,
      x: 5.23,
      y: 2.97,
    },
    {
      path: infoIconOutline,
      h: 0.35,
      w: 0.35,
      x: 4.14,
      y: 6.44,
    },
  ];
};
